var paragraph_default = {
  "fontElementMap": "lScw6",
  "elementSpacing": "Ez0XR",
  "text": "_3deA0 Ez0XR",
  "child": "QRhFB"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
